import { render } from "./StatusDialog.vue?vue&type=template&id=e8f61eba"
import script from "./StatusDialog.vue?vue&type=script&lang=js"
export * from "./StatusDialog.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__